class Validator {
    charsetUpper = 'upper'
    charsetLower = 'lower'
    charsetNum = 'num'
    charsetSign = 'sign'

    regxUpper = /[A-Z]+/
    regxLower = /[a-z]+/
    regxNum = /[0-9]+/
    regxSign = /['.,:*?~`!@#$%^&+=)(<>{}]|\]|\[|\/|\\\|"|\|/
    regxSpace = /\s+/

    levelStrong = 'strong'
    levelNormal = 'normal'
    levelWeak = 'weak'
    levelLeast = 'least'
    levelFail = 'fail'

    rules = {}

    constructor(rules) {
        this.rules = rules
    }

    /**
     * 获取强度
     * @param string
     * @return string
     */
    strength(string) {
        let strong = this.strong(string)
        if (strong) {
            return this.levelStrong
        }
        let normal = this.normal(string)
        if (normal) {
            return this.levelNormal
        }
        let weak = this.weak(string)
        if (weak) {
            return this.levelWeak
        }
        let least = this.least(string)
        if (least) {
            return this.levelLeast
        }
        return this.levelFail
    }

    /**
     * 验证密码，只验证最低要求即可
     * @param string
     * @return {msg: string, type: (string|*)}
     */
    validate(string) {
        let space = this.space(string)
        if (space) {
            return '密码不能包含空格'
        }
        let rule = this.rules['least']
        if (!rule) {
            rule = this.rules['weak']
        }
        let length = this.length(string, rule['length'])
        if (!length) {
            let lengthRule = this.analyseLengthRule(rule['length'])
            let msg
            if (lengthRule['max']) {
                msg = '密码长度' + lengthRule['min'] + '~' + lengthRule['max'] + '个字符'
            } else {
                msg = '密码不能少于' + lengthRule['min'] + '个字符'
            }
            return msg
        }
        let limit = this.charSet(string, rule)
        if (limit < rule['limit']) {
            let msg = ''
            if (rule['limit'] === rule['in'].length) {
                msg = '密码必须包含' + this.analyseCharsetNames(rule['in'], '，')
            } else {
                msg = '密码必须包含' + this.analyseCharsetNames(rule['in'], '，') + '中的' + this.analyseLimitName(rule['limit']) + '种'
            }
            return msg
        }
        if (typeof rule['successive'] != 'undefined' && !rule['successive']) {
            let successive = this.successive(string, rule['successive'])
            if (successive) {
                return '密码不能包含连续字符'
            }
        }
        return true
    }

    /**
     * 最低要求验证
     * @param string
     * @return boolean
     */
    least(string) {
        return this.check(string, 'least')
    }

    /**
     * 弱强度密码验证
     * @param string
     * @return boolean
     */
    weak(string) {
        return this.check(string, 'weak')
    }

    /**
     * 中强度密码验证
     * @param string
     * @return boolean
     */
    normal(string) {
        return this.check(string, 'normal')
    }

    /**
     * 强强度密码验证
     * @param string
     * @return boolean
     */
    strong(string) {
        return this.check(string, 'strong')
    }

    /**
     * 判断是否满足要求
     * @param string
     * @param $level
     * @return boolean
     */
    check(string, level) {
        let rule = this.rules[level]
        let length = this.length(string, rule['length'])
        if (!length) {
            return false
        }
        let space = this.space(string)
        if (space) {
            return false
        }
        let limit = this.charSet(string, rule)
        if (limit < rule['limit']) {
            return false
        }
        if (typeof rule['successive'] != 'undefined' && !rule['successive']) {
            let successive = this.successive(string, rule['successive'])
            if (!successive) {
                return false
            }
        }
        return true
    }

    analyseLimitName(limit) {
        switch (limit) {
            case 1:
                return '一';
            case 2:
                return '两';
            case 3:
                return '三';
            case 4:
                return '四';
            default:
                return '';
        }
    }

    analyseCharsetName(charset) {
        switch (charset) {
            case this.charsetUpper:
                return '大写字母'
            case this.charsetLower:
                return '小写字母'
            case this.charsetNum:
                return '数字'
            case this.charsetSign:
                return '特殊字符'
            default:
                return ''
        }
    }

    /**
     * 获取字符名称
     * @param rule
     * @returns string|{*[]}
     */
    analyseCharsetNames(rule, join) {
        if (join) {
            let charsetName = ''
            let ruleLen = rule.length
            for (let index in rule) {
                if (index === 0) {
                    charsetName = this.analyseCharsetName(rule[index])
                } else if (index === (ruleLen - 1)) {
                    charsetName = charsetName + '和' + this.analyseCharsetName(rule[index])
                } else {
                    charsetName = charsetName + '、' + this.analyseCharsetName(rule[index])
                }
            }
            return charsetName
        } else {
            let charsetName = []
            for (let charset of rule) {
                switch (charset) {
                    case this.charsetUpper:
                        charsetName.push('大写字母')
                        break
                    case this.charsetLower:
                        charsetName.push('小写字母')
                        break
                    case this.charsetNum:
                        charsetName.push('数字')
                        break
                    case this.charsetSign:
                        charsetName.push('特殊字符')
                        break
                    default:
                        console.log('Unknown character type:' + charset)
                }
            }
            return charsetName
        }
    }

    /**
     * 验证字符类型
     * @param string
     * @param rule
     * @returns {number}
     */
    charSet(string, rule) {
        let limit = 0
        for (let inItem of rule['in']) {
            let validate = false
            switch (inItem) {
                case this.charsetUpper:
                    validate = this.upper(string)
                    break
                case this.charsetLower:
                    validate = this.lower(string)
                    break
                case this.charsetNum:
                    validate = this.num(string)
                    break
                case this.charsetSign:
                    validate = this.sign(string)
                    break
                default:
                    console.log('Unknown character type:' + inItem)
                /**
                 * @todo nothing
                 */
            }
            if (validate) {
                limit++
                if (limit === rule['limit']) {
                    break
                }
            }
        }
        return limit;
    }

    /**
     * 是否包含大写字母
     * @param string
     * @return boolean
     */
    upper(string) {
        if (this.regxUpper.test(string)) {
            return true
        }
        return false
    }

    /**
     * 是否包含小写字母
     * @param string
     * @return boolean
     */
    lower(string) {
        if (this.regxLower.test(string)) {
            return true
        }
        return false
    }

    /**
     * 是否包含数字
     * @param string
     * @return boolean
     */
    num(string) {
        if (this.regxNum.test(string)) {
            return true
        }
        return false
    }

    /**
     * 是否包含特殊字符
     * @param string
     * @return boolean
     */
    sign(string) {
        if (this.regxSign.test(string)) {
            return true
        }
        return false
    }

    /**
     * 是否包含空格
     * @param string
     * @returns {boolean}
     */
    space(string) {
        if (this.regxSpace.test(string)) {
            return true
        }
        return false
    }

    /**
     * 判断是否有连续
     * @param string
     * @return boolean
     */
    successive(string, limit) {
        let strLen = string.length
        let repeatCount = 0
        const reg = /^\d$/
        for (let index = 1; index < strLen; index++) {
            let diff
            let current = string[index]
            if (reg.test(current)) {
                //数字直接比较
                diff = Math.abs(string[index - 1] - current)
            } else {
                //字母转换为Unicode编码再比较
                // let lastChar = string[index - 1].charCodeAt(0)
                // let thisChar = current.charCodeAt(0)
                // diff = Math.abs(lastChar - thisChar)
                if (current === string[index - 1]) {
                    diff = 0;
                } else {
                    diff = 2;
                }
            }
            if (diff <= 1) {
                repeatCount += 1
            } else {
                repeatCount = 0
            }
        }
        if (typeof limit == 'boolean') {
            limit = 6
        }
        if (repeatCount < limit) {
            return true
        }
        return false
    }

    /**
     * 解析长度限制配置
     * @param rule
     * @returns {{min: *, max: null}|boolean}
     */
    analyseLengthRule(rule) {
        let max = null
        let min = 0
        if (rule instanceof Array) {
            min = rule[0]
            max = rule[1] ?? null
        } else if (typeof value === 'number' && !isNaN(rule)) {
            min = rule
        } else {
            console.log('长度限制配置错误')
            return false
        }
        return {min: min, max: max}
    }

    /**
     * @param string
     * @param limit
     * @return boolean
     */
    length(string, limit) {
        let length = string.length
        let rule = this.analyseLengthRule(limit)
        if (rule === false) {
            return false
        }
        if (length < rule['min']) {
            return false
        }
        if (rule['max'] != null) {
            if (length > rule['max']) {
                return false
            }
        }
        return true
    }
}

export default Validator
